// libs
import React, { useRef, useEffect, memo } from 'react';

// contexts
import { useWidgetContext } from 'shared/layouts/DetailsPage/components/WidgetProvider/WidgetContext';

// styles
import { WidgetTop } from './styles';

function WidgetTopRef(props) {
  const widgetRef = useRef<HTMLDivElement>(null);
  const { setWidgetEl } = useWidgetContext();

  useEffect(() => {
    setWidgetEl(widgetRef);
  }, [setWidgetEl]);

  return (
    <WidgetTop {...props}>
      <div ref={widgetRef} className="pointer" />
    </WidgetTop>
  );
}

export default memo(WidgetTopRef);
